'use client';

import { useTranslation } from '@/contexts/dictionaryContext';
import { Experience } from '@/services/experienceTypes';
import getMediaFilterUrl from '@/utils/get-media-filter';
import Image from 'next/image';
import { FC, HTMLAttributes } from 'react';
import { MapContent } from './MapContent';

interface IExperienceMapProps extends HTMLAttributes<HTMLDivElement> {
  experience: Experience;
}

export const ExperienceMap: FC<IExperienceMapProps> = ({ experience }) => {
  const { experienceInfo: dict } = useTranslation();

  const coverMedia = experience.media.filter(
    (medias) => medias.type == 'cover',
  )[0];
  const experienceImgCover = getMediaFilterUrl({
    mediaFilters: coverMedia.mediaFilters,
    filterName: 'small_1-1',
  });

  const experienceLocation = {
    lat: experience.location.latitude,
    lng: experience.location.longitude,
  };

  return (
    <div
      id="map"
      className="flex flex-col w-full px-sm md:px-md desktop:px-lg mb-[30px] sm:mb-[50px] desktop:mb-20">
      <div className="relative">
        <div className="desktop:absolute desktop:top-[11px] desktop:left-[11px] flex items-center gap-5 w-full desktop:w-[305px] min-h-[80px] desktop:min-h-[50px] bg-white z-[1] shadow-[0_10px_20px_-0_rgba(0,0,0,0.1)]">
          <div className="h-20 w-20 min-w-20">
            <Image
              src={experienceImgCover ? experienceImgCover : ''}
              alt="Photo cover experience"
              width={80}
              height={80}
              className="opacity-100 transition-all duration-300 ease-in-out w-full h-full object-cover object-[50%_50%] inline-block align-middle max-w-full"
              sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
            />
          </div>
          <div>
            <strong>{dict.meetingPoint}</strong>
            <p>
              {experience.city}
              {experience.province && ` , ${experience.province.name}`}
            </p>
          </div>
        </div>
        <MapContent experienceLocation={experienceLocation} />
      </div>
    </div>
  );
};
